export { BasePortalHost, ComponentPortal } from './portal/portal';
export { Overlay } from './overlay/overlay';
export { OverlayContainer } from './overlay/overlay-container';
export { OverlayRef } from './overlay/overlay-ref';
export { ToastContainerModule, ToastContainerDirective } from './toastr/toast-directive';
export { Toast } from './toastr/toast-component';
export { ToastrService } from './toastr/toastr-service';
export { ToastrConfig, ToastConfig, ToastData } from './toastr/toastr-config';
export { ToastrModule } from './toastr/toastr-module';
export { ToastRef } from './toastr/toast-injector';



//////////////////
// WEBPACK FOOTER
// ./~/ngx-toastr/index.js
// module id = 77
// module chunks = 4